import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdminSession, useBrowserSession } from '../_lib/browserSession';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const session = useBrowserSession();
    const allowed = isAdminSession(session);
    return (
        <Route {...rest} render={props => (
            allowed ? <Component {...props} /> : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )} />
    );

};

export default PrivateRoute;
